import { connect } from 'react-redux';

import { SocialLoginButtons } from '@eventbrite/social-login-facebook';

import {
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialLogInUserAuthorized as socialLogInUserAuthorizedAction,
    socialConnectVerified as socialConnectVerifiedAction,
    socialProviderClick as socialProviderClickAction,
} from '../actions/social';

const _mapStateToProps = ({ authentication, social }) => ({
    socialSSOSettings: social.socialSSOSettings,
    fp: authentication.fp,
});

const _mapDispatchToProps = {
    onSocialConnectNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialLogInUserAuthorized: socialLogInUserAuthorizedAction,
    onSocialConnectVerified: socialConnectVerifiedAction,
    handleSocialProviderClick: socialProviderClickAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SocialLoginButtons);
